import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AppStorage } from '../../services/appStorage.service';

@Component({
  selector: 'app-modal-error-no-sesion',
  templateUrl: './modal-error-no-sesion.component.html',
  styleUrls: ['./modal-error-no-sesion.component.css']
})
export class ModalNoSesionComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalNoSesionComponent>,
    private appStorage: AppStorage
  ) {}

  ngOnInit() {}

  close(): void {
    // Redirigir a 'debe iniciar sesion'
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    this.appStorage.conSesion = false;
    this.appStorage.loadingSesion = false;
    this.dialogRef.close();
  }
}
